import { Children } from "react";
import Link from "next/link";
import { v4 } from "uuid";
import * as DialogPrimitive from "@radix-ui/react-dialog";

import { useToastFeedbackUser } from "@aprosoja/stores";
import { NewsType } from "@aprosoja/types";
import {
  Button,
  Dialog,
  DialogClose,
  DialogContent,
  DialogTitle,
  IconButton,
  Text,
} from "@aprosoja/ui";

import {
  FacebookSvg,
  TwitterXSvg,
  WhatsappSvg,
  LinkedinSvg,
  PinterestSvg,
} from "./components/socials-svgs";

type ShareNewsModalProps = DialogPrimitive.DialogProps & {
  news?: NewsType;
};

const ShareNewsModal = ({ news, ...rest }: ShareNewsModalProps) => {
  const { setToast } = useToastFeedbackUser();
  const currentUrl = window.location.href;

  const socials = [
    {
      name: "facebook",
      icon: <FacebookSvg color="#ffffff" />,
      link: `https://www.facebook.com/sharer/sharer.php?u=${currentUrl}`,
    },
    {
      name: "twitter",
      icon: <TwitterXSvg color="#ffffff" />,
      link: `https://x.com/share?url=${currentUrl}`,
    },
    {
      name: "whatsapp",
      icon: <WhatsappSvg color="#ffffff" />,
      link: `https://wa.me/?text=${currentUrl}`,
    },
    {
      name: "linkedin",
      icon: <LinkedinSvg color="#ffffff" />,
      link: `http://www.linkedin.com/shareArticle?mini=true&url=${currentUrl}`,
    },
    {
      name: "pinterest",
      icon: <PinterestSvg color="#ffffff" />,
      link: `http://pinterest.com/pin/create/link/?url=${currentUrl}&media=${news?.imageUrl ?? ""}&description=${news?.title ?? ""}`,
    },
  ];

  return (
    <Dialog {...rest}>
      <DialogContent className="w-full flex flex-col gap-size-x6 px-size-x6 py-size-x8 rounded-border-radius-large bg-th-color-neutral-100">
        <div className="absolute top-2 right-2">
          <DialogClose asChild>
            <IconButton
              className="rounded-border-radius-small"
              name="close"
              size="large"
              variant="ghost"
            />
          </DialogClose>
        </div>
        <DialogTitle>
          <Text type="headingL">Compartilhar</Text>
        </DialogTitle>
        <div className="flex w-full gap-size-x4">
          {Children.toArray(
            socials.map((social) => (
              <Link href={social.link} target="_blank">
                <Button size="large" className="rounded-border-radius-small">
                  {social.icon}
                </Button>
              </Link>
            ))
          )}
        </div>
        <div className="flex flex-col w-full gap-size-x2">
          <Text type="labelL">Link da página</Text>
          <div className="flex w-full justify-between items-center p-size-x2 bg-th-color-neutral-0 border-border-width-thin border-th-color-neutral-200 rounded-border-radius-small">
            <Text type="paragraphS">{currentUrl}</Text>
            <IconButton
              name="stack"
              variant="ghost"
              size="small"
              onClick={() => {
                navigator.clipboard.writeText(currentUrl);
                setToast({
                  id: v4(),
                  title: "Link copiado!",
                  status: "success",
                });
              }}
            />
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ShareNewsModal;
